import React from 'react';
import { motion } from 'framer-motion';
import {
  HiOutlineAcademicCap,
  HiOutlineClipboardCheck,
  HiOutlineCode,
  HiOutlineCubeTransparent,
  HiOutlineSearch,
  HiOutlineViewGrid,
} from 'react-icons/hi';

const processes = [
  { icon: HiOutlineSearch, title: 'Descoberta', desc: 'Levantamento das regras do negócio, gargalos e metas do projeto antes de falar em tela ou botão.' },
  { icon: HiOutlineViewGrid, title: 'Modelagem', desc: 'Desenho do fluxo ideal para a operação ganhar clareza e reduzir esforço desnecessário.' },
  { icon: HiOutlineCubeTransparent, title: 'Integrações', desc: 'Estruturação técnica e conexão com ferramentas externas, fiscal e comunicação.' },
  { icon: HiOutlineClipboardCheck, title: 'Planejamento', desc: 'Entregas por prioridade, com visão concreta do que entra primeiro e por quê.' },
  { icon: HiOutlineCode, title: 'Implementação', desc: 'Desenvolvimento com foco em estabilidade, legibilidade e evolução futura.' },
  { icon: HiOutlineAcademicCap, title: 'Implantação', desc: 'Treinamento, ajustes finais e entrada em produção com acompanhamento próximo.' },
];

const variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      staggerChildren: 0.08,
    },
  },
};

const itemVariant = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0 },
};

function Feature() {
  return (
    <section
      id="feature"
      className="section-padding"
      style={{ background: 'linear-gradient(180deg, #FAFEFF 0%, #EBF6FC 100%)', position: 'relative', overflow: 'hidden' }}
    >
      <div
        style={{
          position: 'absolute',
          top: '-12%',
          right: '-6%',
          width: '460px',
          height: '460px',
          background: 'radial-gradient(circle, rgba(107,189,223,0.14) 0%, transparent 70%)',
          borderRadius: '50%',
          pointerEvents: 'none',
        }}
      />

      <div className="container">
        <div className="row align-items-center" style={{ rowGap: '32px' }}>
          <div className="col-lg-5 col-md-12 col-sm-12">
            <motion.div initial="hidden" animate="visible" variants={variants}>
              <motion.p
                variants={itemVariant}
                style={{
                  display: 'inline-flex',
                  padding: '8px 14px',
                  borderRadius: '9999px',
                  background: 'rgba(59,158,212,0.08)',
                  color: '#2178AB',
                  fontWeight: 700,
                  marginBottom: '18px',
                }}
              >
                Do briefing à produção
              </motion.p>

              <motion.h2 variants={itemVariant} style={{ color: '#1A2D3A', fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 800, marginBottom: '18px' }}>
                Nosso processo evita retrabalho e acelera decisão.
              </motion.h2>

              <motion.p variants={itemVariant} style={{ color: '#4A6680', fontSize: '1.08rem', lineHeight: 1.8, marginBottom: '28px' }}>
                A entrega funciona melhor quando a arquitetura nasce a partir da operação. Por isso a ordem importa: entender, desenhar, integrar, construir e implantar.
              </motion.p>

              <motion.div variants={itemVariant} style={{ padding: '22px', borderRadius: '24px', background: 'rgba(255,255,255,0.86)', border: '1px solid rgba(59,158,212,0.12)', boxShadow: '0 12px 28px rgba(59,158,212,0.08)' }}>
                <strong style={{ color: '#1A2D3A', display: 'block', marginBottom: '8px' }}>Entrega com leitura de negócio</strong>
                <p style={{ color: '#5A7A8E', lineHeight: 1.7 }}>
                  Menos improviso em produção, mais previsibilidade no que entra no sistema e no que a equipe realmente consegue usar.
                </p>
              </motion.div>
            </motion.div>
          </div>

          <div className="col-lg-7 col-md-12 col-sm-12">
            <motion.div
              className="process-list"
              style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' }}
              initial="hidden"
              animate="visible"
              variants={variants}
            >
              {processes.map((proc, index) => {
                const Icon = proc.icon;

                return (
                  <motion.article
                    key={proc.title}
                    variants={itemVariant}
                    whileHover={{ y: -6, boxShadow: '0 18px 38px rgba(59,158,212,0.14)' }}
                    style={{
                      display: 'flex',
                      gap: '16px',
                      alignItems: 'flex-start',
                      background: 'rgba(255,255,255,0.92)',
                      padding: '22px',
                      borderRadius: '20px',
                      border: '1px solid rgba(59, 158, 212, 0.14)',
                      boxShadow: '0 8px 22px rgba(59,158,212,0.08)',
                    }}
                  >
                    <div
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '14px',
                        flexShrink: 0,
                        background: 'linear-gradient(135deg, rgba(59,158,212,0.18) 0%, rgba(107,189,223,0.26) 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Icon size={24} color="#2178AB" />
                    </div>
                    <div>
                      <p style={{ color: '#6A8899', fontWeight: 700, fontSize: '0.78rem', marginBottom: '6px' }}>
                        ETAPA {String(index + 1).padStart(2, '0')}
                      </p>
                      <h4 style={{ color: '#1A2D3A', fontSize: '1.08rem', fontWeight: 700, marginBottom: '8px' }}>{proc.title}</h4>
                      <p style={{ color: '#5A7A8E', fontSize: '0.94rem', lineHeight: 1.65 }}>{proc.desc}</p>
                    </div>
                  </motion.article>
                );
              })}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Feature;
